<template>
    <span v-if="editMode" class="vue-resizable-handle"></span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    components: {},
    name: 'custom-resize',
    computed: {
        ...mapGetters({
            editMode: 'dashboard/editMode',
            theme: 'user/theme'
        }),
        theme() {
            return this.theme.theme
        }
    }
}
</script>

<style lang="scss">
.theme-dark {
    .vue-resizable-handle {
        background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHlsZT0id2lkdGg6NXB4OyBoZWlnaHQ6NXB4Ij4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjZWJlZWZkOyBmaWxsOiAjZWJlZWZkOyIgY3g9IjE3Ny4zODIiIGN5PSIyMi42MTgiIHJ4PSIyMi42MTgiIHJ5PSIyMi42MTgiIC8+CiAgPGVsbGlwc2Ugc3R5bGU9InN0cm9rZTogI2ViZWVmZDsgZmlsbDogI2ViZWVmZDsiIGN4PSIxMDAiIGN5PSIxNzcuMzgyIiByeD0iMjIuNjE4IiByeT0iMjIuNjE4IiAvPgogIDxlbGxpcHNlIHN0eWxlPSJzdHJva2U6ICNlYmVlZmQ7IGZpbGw6ICNlYmVlZmQ7IiBjeD0iMjIuNjE4IiBjeT0iMTc3LjM4MiIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjZWJlZWZkOyBmaWxsOiAjZWJlZWZkOyIgY3g9IjE3Ny4zODIiIGN5PSIxNzcuMzgyIiByeD0iMjIuNjE4IiByeT0iMjIuNjE4IiAvPgogIDxlbGxpcHNlIHN0eWxlPSJzdHJva2U6ICNlYmVlZmQ7IGZpbGw6ICNlYmVlZmQ7IiBjeD0iMTc3LjM4MiIgY3k9IjEwMCIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjZWJlZWZkOyBmaWxsOiAjZWJlZWZkOyIgY3g9IjEwMCIgY3k9IjEwMCIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KPC9zdmc+');
    }
}
.vue-resizable-handle {
    position: absolute;
    width: 2px;
    height: 2px;
    bottom: 0;
    right: 0;
    background-position: 100% 100%;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat !important;
    background-origin: content-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: se-resize;
    stroke: red;
    z-index: 2;
    //light svg
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHlsZT0id2lkdGg6NXB4OyBoZWlnaHQ6NXB4Ij4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjMmMyYzJjOyBmaWxsOiAjMmMyYzJjOyIgY3g9IjE3Ny4zODIiIGN5PSIyMi42MTgiIHJ4PSIyMi42MTgiIHJ5PSIyMi42MTgiIC8+CiAgPGVsbGlwc2Ugc3R5bGU9InN0cm9rZTogIzJjMmMyYzsgZmlsbDogIzJjMmMyYzsiIGN4PSIxMDAiIGN5PSIxNzcuMzgyIiByeD0iMjIuNjE4IiByeT0iMjIuNjE4IiAvPgogIDxlbGxpcHNlIHN0eWxlPSJzdHJva2U6ICMyYzJjMmM7IGZpbGw6ICMyYzJjMmM7IiBjeD0iMjIuNjE4IiBjeT0iMTc3LjM4MiIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjMmMyYzJjOyBmaWxsOiAjMmMyYzJjOyIgY3g9IjE3Ny4zODIiIGN5PSIxNzcuMzgyIiByeD0iMjIuNjE4IiByeT0iMjIuNjE4IiAvPgogIDxlbGxpcHNlIHN0eWxlPSJzdHJva2U6ICMyYzJjMmM7IGZpbGw6ICMyYzJjMmM7IiBjeD0iMTc3LjM4MiIgY3k9IjEwMCIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KICA8ZWxsaXBzZSBzdHlsZT0ic3Ryb2tlOiAjMmMyYzJjOyBmaWxsOiAjMmMyYzJjOyIgY3g9IjEwMCIgY3k9IjEwMCIgcng9IjIyLjYxOCIgcnk9IjIyLjYxOCIgLz4KPC9zdmc+');
}
</style>
